import React,{Component} from 'react';
import PropTypes from 'prop-types';

class Message extends Component {
    componentDidMount() {
        setTimeout(this.props.delMessage, 2000);
    }

    render() {
        let props = this.props;
        return (
            <div className="messageWrapper" onClick={props.delMessage}>
                <div className={(props.error ? 'error': 'success') + ' messageBox'}>
                    {props.children}
                </div>
            </div>
        );
    }
}

Message.propTypes = {
    error: PropTypes.bool,
    delMessage: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export {Message};